import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./terms.css";
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
function TermsandCondition() {
    const navigate = useNavigate();
    const [termsAgreed, setTermsAgreed] = useState(false);
    const [error, setError] = useState(''); // State to hold error message
    const [generalData, setgeneraldata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [htmlTerms, setHtmlTerms] = useState([])
    
    useEffect(() => {
        const fetchsetsData = async () => {
        try {
            const response = await apiService.getRequest('/general-settings');
            if(response && response.success === true){
                setgeneraldata(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }
        };
        fetchsetsData();
    }, []);

    useEffect(() => {
        const fetchsetsterms = async () => {
            setLoading(true)
        try {
            const response = await apiService.postRequest('/latest/terms');
            if(response && response.success === true){
                setHtmlTerms(response.data);
            }
        } catch (error) {
            console.error('Error', error);
        }finally{
            setLoading(false);
        }
        };
        fetchsetsterms();
    }, []);
    // Handle checkbox change
    const handleCheckboxChange = (e) => {
      setTermsAgreed(e.target.checked);
      setError(''); // Clear error if checkbox is checked
    };
  
    // Handle form submission
    const handleSubmit = (e) => {
      e.preventDefault();
      if (termsAgreed) {
        navigate("/registration");
        localStorage.setItem('termid', htmlTerms.id);
      } else {
        setError('You must agree to the terms and conditions to proceed.');
      }
    };
    
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
    <Grid size={{xs:12}} container justifyContent="center" className="termsconditionmain">
        <Grid size={{md:10,xs:11}} container justifyContent="flex-start" alignItems="flex-start" flexDirection="column">
            {generalData && generalData.site_logo ? <img onClick={() =>{navigate("/")}} src={generalData.site_logo} alt=''/> :
                <img onClick={() =>{navigate("/")}} src={require("../../assets/logo.svg").default} alt=''/>
            }
            <h2>Terms and Conditions</h2>
            {loading ? 
            <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :<>
                <div className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(htmlTerms.content) }} />
            </>}
        </Grid>
        <Grid size={{md:10,xs:11}} container justifyContent="center">
          {loading ? "":
          <form onSubmit={handleSubmit} className='d-flex w-100 flex-column align-items-center'>
              <span>
                <input 
                  type="checkbox" 
                  id="terms" 
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="terms">I agree to the Terms & Conditions <span>*</span></label>
              </span>
              {error && <p style={{ color: 'red', marginTop: '10px',width:"100%" }}>{error}</p>} {/* Display error message */}
              <button type="submit" className={!termsAgreed ? "disabled_btns" : ""}>
                Submit
              </button>
          </form>
          }
        </Grid>
    </Grid>
  )
}

export default TermsandCondition
